import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { UnreadHorseNotification } from '@sleipai/sleip-models';

export type UnreadNotificationCountsByHorseState =
  EntityState<UnreadHorseNotification>;

export const unreadNotificationCountsByHorseAdapter: EntityAdapter<UnreadHorseNotification> =
  createEntityAdapter<UnreadHorseNotification>({
    selectId: (unreadHorseNotification: UnreadHorseNotification) =>
      unreadHorseNotification.horseId,
  });

export const {
  selectIds: selectUnreadNotificationCountsByHorseIdsAdapter,
  selectEntities: selectUnreadNotificationCountsByHorseEntitiesAdapter,
  selectAll: selectAllUnreadNotificationCountsByHorseAdapter,
  selectTotal: selectUnreadNotificationCountsByHorseTotalAdapter,
} = unreadNotificationCountsByHorseAdapter.getSelectors();
